var map = {
	"./lg__az.png": "d6bf",
	"./lg__bras.png": "05e4",
	"./lg__cs.png": "d6d6",
	"./lg__da.png": "f82d",
	"./lg__de.png": "8806",
	"./lg__el.png": "2253",
	"./lg__en.png": "8e11",
	"./lg__es.png": "7e22",
	"./lg__et.png": "9dc0",
	"./lg__fr.png": "cae0",
	"./lg__hy.png": "4aa2",
	"./lg__ja.png": "fa7f",
	"./lg__ko.png": "737e",
	"./lg__lt.png": "0371",
	"./lg__lv.png": "8765",
	"./lg__no.png": "9a47",
	"./lg__pl.png": "5732",
	"./lg__pt.png": "18fb",
	"./lg__ru.png": "2d7a",
	"./lg__sv.png": "8af4",
	"./lg__tr.png": "6206",
	"./lg__uk.png": "7a68",
	"./lg__usa.png": "5134",
	"./lg__zh.png": "1327"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7be";